import { render, staticRenderFns } from "./BackView.vue?vue&type=template&id=caa8a966&scoped=true&lang=pug&"
import script from "./BackView.vue?vue&type=script&lang=js&"
export * from "./BackView.vue?vue&type=script&lang=js&"
import style0 from "./BackView.vue?vue&type=style&index=0&id=caa8a966&lagn=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa8a966",
  null
  
)

export default component.exports